import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, AlertTriangle, TrendingUp, Sparkles } from "lucide-react";

/**
 * VAULT Health widget — small card the Concierge dashboard mounts.
 * Full page could live at /vault-health later. Widget shows the
 * 0-100 organisational score + the top attention item.
 */
export default function VaultHealthCard() {
    const [d, setD] = useState(null);
    useEffect(() => {
        api.get("/vault-health").then((r) => setD(r.data)).catch(() => setD(null));
    }, []);
    if (!d) return null;
    const tone = d.score >= 90 ? "emerald" : d.score >= 75 ? "amber" : d.score >= 50 ? "orange" : "rose";
    const toneCls = {
        emerald: "text-emerald-700 bg-emerald-50 border-emerald-200",
        amber:   "text-amber-800 bg-amber-50 border-amber-200",
        orange:  "text-orange-800 bg-orange-50 border-orange-200",
        rose:    "text-rose-800 bg-rose-50 border-rose-200",
    }[tone];
    const top = d.improve?.[0];

    return (
        <div className="rounded-2xl border border-stone-200 bg-white p-5" data-testid="vault-health-card">
            <div className="flex items-center gap-2 mb-3">
                <Sparkles size={13} className="text-amber-700" />
                <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-500">VAULT Health</span>
            </div>
            <div className="flex items-end gap-2">
                <div className="text-4xl font-semibold tabular-nums text-stone-900 leading-none">{d.score}</div>
                <div className="text-[10px] uppercase tracking-widest text-stone-500 pb-1">/100</div>
            </div>
            <div className={`inline-flex items-center gap-1 mt-2 px-2 py-0.5 rounded-full text-[10.5px] font-bold uppercase tracking-widest border ${toneCls}`}>
                {d.category}
            </div>
            <div className="mt-3 text-[11.5px] text-stone-500">
                {d.factors.length} positive · {d.attention.length} to improve
            </div>
            {top && (
                <Link to={top.cta || "#"} data-testid="vault-health-top-action"
                      className="mt-3 flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-[12.5px] text-amber-900 hover:bg-amber-100">
                    <AlertTriangle size={12} />
                    <span className="flex-1">{top.text}</span>
                    <TrendingUp size={11} />
                </Link>
            )}
            <p className="mt-3 text-[10.5px] text-stone-400 leading-snug">{d.disclosure}</p>
        </div>
    );
}
